import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Input } from 'reactstrap';
import { AFAS_TABS, formatAfasTabLabel } from '../tabs';
import { useAfasContext } from '../context/AfasContext';

const AfasTabSelect = ({ className = 'form-select form-select-sm' }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { tabCounts } = useAfasContext();

    const activeTab =
        AFAS_TABS.find((tab) => location.pathname.includes(`/afas/${tab.key}`))?.key ??
        AFAS_TABS[0].key;

    return (
        <Input
            type="select"
            className={className || 'form-select form-select-sm'}
            value={activeTab}
            onChange={(event) => navigate(`/afas/${event.target.value}`)}
            aria-label="Afas tab"
        >
            {AFAS_TABS.map((tab) => (
                <option key={tab.key} value={tab.key}>
                    {formatAfasTabLabel(tab, tabCounts)}
                </option>
            ))}
        </Input>
    );
};

export default AfasTabSelect;
